import React from 'react';
import {Link, Redirect} from 'react-router-dom';
import Button from 'components/CustomButtons/Button.jsx';
import TextField from '@material-ui/core/TextField';
import PropTypes from 'prop-types';
import LoadingComponent from 'components/inc/LoadingComponent';
import { connect } from 'react-redux';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { getProjectDetails } from '../../../actions/project';
import { saveSprint, updateSprint } from '../../../actions/sprint';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

import {FormControlLabel, Grid, Radio, RadioGroup} from '@material-ui/core';

class SprintForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sprintTitle: props.sprint ? props.sprint.title : '',
      sprintType: props.sprint ? props.sprint.sprintType : '',
      editSprint: '',
      isLoading: false,
      newSprintId: null,
      sprintUpdated: false,
    };
    this.onSubmit = this.onSubmit.bind(this);
  }

  handleSprintTypeChange = ({ target: { value } }) => {
    this.setState({ sprintType: value });
  };

  handleSprintTitle = (event) => {
    this.setState({ sprintTitle: event.target.value });
  };

  handleSprintTitleValidation = (event) => {
    if (!event.target.value) {
      this.setState({ sprintTitleError: true });
    } else {
      this.setState({ sprintTitleError: false });
    }
  };

  async onSubmit(e) {
    e.preventDefault();
    if (!this.state.sprintTitle) {
      this.setState({
        sprintTitleError: true,
      });
      return;
    }
    this.setState({ isLoading: true });
    if (this.state.sprintTitle && this.state.sprintType) {
      const data = {
        title: this.state.sprintTitle,
        sprintType: this.state.sprintType,
      };
      const response = this.props.sprint
        ? await this.props.updateSprint(
            data,
            this.props.sprint.project,
            this.props.sprint._id
          )
        : await this.props.saveSprint(data, this.props.project._id);
      if (this.props.sprint && response.success) {
        this.setState({
          sprintUpdated: true,
        });
      }
      if (!this.props.sprint && response.success) {
        this.setState({
          newSprintId: response.data._id,
        });
      }
      this.setState({ isLoading: false });
    }
  }

  render() {
    if (this.state.newSprintId) {
      return (
        <Redirect
          to={`/projects/${this.props.project._id}/sprints/${
            this.state.newSprintId
          }/create-story`}
        />
      );
    }
    if (this.state.sprintUpdated) {
      return (
        <Redirect
          to={`/projects/${this.props.sprint.project}/sprints/${
            this.props.sprint._id
          }`}
        />
      );
    }
    return (
      <div>
        <LoadingComponent isLoading={this.state.isLoading}>
          <form onSubmit={this.onSubmit}>
            <div className='form-element'>
              <div className='title form-label'>
                <h3 className='form-label-text'>Title:</h3>
              </div>
              <TextField
                id='regular'
                inputProps={{
                  maxLength: 150,
                  placeholder: '',
                }}
                className='form-textfield'
                fullWidth={true}
                error={this.state.sprintTitleError}
                value={this.state.sprintTitle}
                onChange={(e) => {
                  this.handleSprintTitle(e);
                }}
                onBlur={(e) => {
                  this.handleSprintTitleValidation(e);
                }}
              />
            </div>
            <div className='form-element'>
              <div className='title form-label'>
                <h3 className='form-label-text'>
                  <span>*</span> Sprint Type
                </h3>
              </div>
              <RadioGroup
                aria-label='sprint type'
                name='sprintType'
                value={this.state.sprintType}
                onChange={this.handleSprintTypeChange}
              >
                <FormControlLabel
                  value='self-service'
                  control={<Radio />}
                  label='Self Service'
                />
                <FormControlLabel
                  value='managed-service'
                  control={<Radio />}
                  label='Managed Service'
                />
              </RadioGroup>
            </div>
            <div className='form-element bottom-actions'>
              {!this.props.sprint && (
                <>
                  <Button
                    type='submit'
                    color='success'
                    className='bottom-action-button'
                    round
                  >
                    Add Story
                  </Button>
                </>
              )}
              {this.props.sprint && (
                <>
                  <Button
                    type='submit'
                    color='success'
                    className='bottom-action-button'
                    round
                  >
                    Save
                  </Button>
                </>
              )}
            </div>
          </form>
        </LoadingComponent>
      </div>
    );
  }
}

SprintForm.contextTypes = {
  router: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => ({});
const mapDispatchToProps = (dispatch) => ({
  getProjectDetails: (projectId) => dispatch(getProjectDetails(projectId)),
  saveSprint: (data, projectId) => dispatch(saveSprint(data, projectId)),
  updateSprint: (data, projectId, sprintId) =>
    dispatch(updateSprint(data, projectId, sprintId)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  { withRef: true }
)(SprintForm);
